import axios from '../axios/axios.service';

export const dataContractApi = {
  getDataContractsByContractType: async (contractType) => {
    return await axios.get(`/data-contracts/${contractType}`);
  },
};
